import {
  CircularProgress,
  makeStyles,
  Theme,
  Typography,
} from "@material-ui/core";
import classNames from "classnames";
import { cloneElement, isValidElement, ReactElement } from "react";
import { getTime, useCircularStyles } from "../../locations/common";

interface Props {
  className?: string;
  valueAsMinutes: number;
  maxValueAsMinutes: number;
  label: string;
  floater?: ReactElement<Props>;
}

const useStyles = makeStyles<Theme>((theme) => ({
  floater: {
    background: theme.palette.background.paper,
    borderRadius: "50%",
  },
}));

export const HosIndicator = ({
  valueAsMinutes,
  maxValueAsMinutes,
  label,
  floater,
  ...props
}: Props) => {
  const classes = useCircularStyles();
  const floaterClasses = useStyles();
  const hasFloater = !!floater && isValidElement<Props>(floater);
  const className = hasFloater
    ? classNames("hos-details-wrapper with-floater", props.className)
    : classNames("hos-details-wrapper", props.className);
  const floaterElement = hasFloater
    ? cloneElement(floater!, {
        className: classNames("floater", floaterClasses.floater),
      })
    : null;
  return (
    <div className={className}>
      <CircularProgress
        variant="determinate"
        className={classes.bottom}
        thickness={5}
        size="4.375rem"
        value={100}
      />
      <CircularProgress
        variant="determinate"
        className="hos-details"
        classes={{
          circle: classes.circle,
        }}
        thickness={5}
        size="4.375rem"
        value={(valueAsMinutes / maxValueAsMinutes) * 100}
      />
      <div className="hos-details-label">
        <Typography variant="body2" component="div">
          {getTime(valueAsMinutes)}
        </Typography>
        <Typography variant="body2" component="div">
          {label}
        </Typography>
      </div>
      {hasFloater ? floaterElement : null}
    </div>
  );
};
